import { useEffect } from 'react';
import SubLucaPlugin from '@/sub-luca-plugin/index';
import OfflineOverlay from '@/components/offline-overlay';
import { INoticeData, IQuestionAnswerProps } from '@/sub-luca-plugin/types';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import { getAccessTokenFn } from '@/utils';

const MicroComponents = ({ microAppType = 'QaDrawer', onReceiveMessageFromMicroApp, registryNoticeMicroAppFn }: IQuestionAnswerProps) => {
    useEffect(() => {
        // 主应用传入的callback
        if (onReceiveMessageFromMicroApp) {
            eventBusExample.subscribe('main-app', onReceiveMessageFromMicroApp);
            eventBusExample.publish('main-app', { type: 'success', params: { content: '通信已建立' } });
        }
        // 主应用获取通信内部的方法
        if (registryNoticeMicroAppFn) {
            if (microAppType === 'EquityModal') {
                registryNoticeMicroAppFn(({ type, params = {} }: INoticeData) => {
                    eventBusExample.publish('EquityModal', { type, params });
                });
            } else {
                registryNoticeMicroAppFn((data: INoticeData) => {
                    const { type, params = {}, callbacks = {} } = data;
                    console.log('接收到主应用的信息', type, params, callbacks);
                    switch (type) {
                        case 'open_rights_modal':
                            eventBusExample.publish('EquityModal', { type: 'open', params });
                            break;
                        default:
                            eventBusExample.publish('QaDrawer', data);
                            break;
                    }
                });
            }
        }
    }, []);

    switch (microAppType) {
        case 'QaDrawer':
            return (
                <>
                    <SubLucaPlugin type="qa" getAccessTokenFn={getAccessTokenFn} />
                    <OfflineOverlay />
                </>
            );
        case 'EquityModal':
            return <SubLucaPlugin type="equity" getAccessTokenFn={getAccessTokenFn} />;
        default:
            return null;
    }
};

export default MicroComponents;
